import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { theme } from 'fpay-ui';

const CustomButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 24px !important;
  gap: 10px;
  background: #43B02A;
  border-radius: 40px !important;
  box-shadow: none;
  height: 40px;
  width: auto;
  ${({ theme }) => theme.breakpoint('new_sm', 'new_lg')} {
  height: 48px;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 24px;  
`;

export default function ({
  text,
  action,
  buttonId
}) {
  return (
    <ButtonContainer>
      <CustomButton onClick={action} id={buttonId}>
        {text}
      </CustomButton>
    </ButtonContainer>

  )
}
